import { Component, OnInit } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { NavigationExtras, Router } from '@angular/router';
import { ToastService } from '@shared/modules/toast/services/toast.service';
import { DataStoreService } from '@shared/services/dataStore.service';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  errDetails: any = {
    title: 'Access Denied',
    description: "We're currently facing technical difficulties, please try again later!",
    reloginButton: true,
    homepageButton: false
  };
  reason: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    private toastService: ToastService,
    private dataStore: DataStoreService
  ) {
    if (this.router.getCurrentNavigation().extras && this.router.getCurrentNavigation().extras.state) {
      if (!this.router.getCurrentNavigation().extras.state.featureUnavailableError) {
        this.authService.destroySession();
      }

      if (this.router.getCurrentNavigation().extras.state.profileFetchError) {
        this.toastService.showToast(
          "We are facing difficulties retrieving user's profile, please check your network connectivity or try again later!",
          'toastError'
        );
        this.errDetails.title = 'User Profile Error';
        this.errDetails.description =
          "We are facing difficulties retrieving user's profile, please check your network connectivity or try again later!";
        this.errDetails.reloginButton = true;
        this.errDetails.homepageButton = false;
      } else if (this.router.getCurrentNavigation().extras.state.featureUnavailableError) {
        this.toastService.showToast('This feature you are trying to access is unavailable!', 'toastError');
        this.errDetails.title = 'Feature Access Error';
        this.errDetails.description = 'This feature you are trying to access is unavailable!';
        this.errDetails.reloginButton = false;
        this.errDetails.homepageButton = true;
      } else if (this.router.getCurrentNavigation().extras.state.sysIdError) {
        this.toastService.showToast(
          "Cannot discover User's SysId. Access to application is blocked! Please contact the system administrator for further assistance!",
          'toastError'
        );
        this.errDetails.title = 'Access Error';
        this.errDetails.description =
          "Cannot discover User's SysId. Access to application is blocked! Please contact the system administrator for further assistance!";
        this.errDetails.reloginButton = false;
        this.errDetails.homepageButton = true;
      } else if (this.router.getCurrentNavigation().extras.state.consentError) {
        this.toastService.showToast(
          "We are facing difficulties retrieving user's profile, please check your network connectivity or try again later!",
          'toastError'
        );
        this.errDetails.title = 'Consent Error';
        this.errDetails.description =
          "We are facing difficulties retrieving user's profile, please check your network connectivity or try again later!";
        this.errDetails.reloginButton = false;
        this.errDetails.homepageButton = true;
      } else if (this.router.getCurrentNavigation().extras.state.unauthorizedError) {
        this.toastService.showToast(
          'You are unauthorized to access the application. Please check your group assignments or contact the system administrator for further assistance!',
          'toastError'
        );
        this.errDetails.title = 'Access Error';
        this.errDetails.description =
          'You are unauthorized to access the application. Please check your group assignments or contact the system administrator for further assistance!';
        this.errDetails.reloginButton = false;
        this.errDetails.homepageButton = true;
      } else if (this.router.getCurrentNavigation().extras.state.apimTokenError) {
        this.toastService.showToast(this.router.getCurrentNavigation().extras.state.message, 'toastError');
        this.errDetails.title = 'Access Token Error';
        this.errDetails.description = this.router.getCurrentNavigation().extras.state.message;
        this.errDetails.reloginButton = true;
        this.errDetails.homepageButton = false;
      } else if (this.router.getCurrentNavigation().extras.state.accessError) {
        this.toastService.showToast('Your account is not onboarded to EAF', 'toastError');
        this.errDetails.title = 'Access Error';
        this.errDetails.description = 'Your account is not onboarded to EAF';
        this.errDetails.reloginButton = true;
        this.errDetails.homepageButton = false;
      } else if (this.router.getCurrentNavigation().extras.state.discoveryDocumentLoadError) {
        this.toastService.showToast(
          'We are facing difficulties accessing the discovery document for performing authorization, please check your network connectivity or try again later!',
          'toastError'
        );
        this.errDetails.title = 'Discovery Document Error';
        this.errDetails.description =
          'We are facing difficulties accessing the discovery document for performing authorization, please check your network connectivity or try again later!';
        this.errDetails.reloginButton = true;
        this.errDetails.homepageButton = false;
      } else if (this.router.getCurrentNavigation().extras.state.canonicalStatusError) {
        this.toastService.showToast(
          'Cannot load canonical state data. Access to application is blocked! Please contact the system administrator for further assistance!',
          'toastError'
        );
        this.errDetails.title = 'Access Error';
        this.errDetails.description =
          'Cannot load canonical status data. Access to application is blocked! Please contact the system administrator for further assistance!';
        this.errDetails.reloginButton = false;
        this.errDetails.homepageButton = true;
      }
    } else {
      this.router.navigate(['auth/login-ad']).then(r => {});
    }

    const reason = this.router.getCurrentNavigation().extras.state.reason
      ? this.router.getCurrentNavigation().extras.state.reason
      : null;
    if (reason) {
      this.reason = ' Error: ' + reason;
    }
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {}

  redirectToLogin() {
    const navigationExtras: NavigationExtras = {
      state: {
        retrySignin: true
      }
    };
    this.router.navigate(['auth/login-ad'], navigationExtras).then(r => {});
  }

  redirectToHomepage() {
    // this.router.navigate(['dashboard/home']).then(r => {});
  }
}
